import axios from 'axios';

import { generateServiceBaseURL, capitalize } from '@/utils/general';
import { requestInterceptor } from '@/plugins/keycloak';

export function imports(i18n, store) {
  const service = axios.create({
    baseURL: generateServiceBaseURL('pv/importe')
  });

  service.interceptors.request.use(requestInterceptor);

  service.interceptors.response.use((response) => response, (error) => {
    if (error.response.status !== 404) {
      const { data } = error.response;
      if (data.translation && i18n.te(data.translation.key)) {
        data.message = i18n.t(data.translation.key, data.translation.params);
      }
      store.commit('notice/add', {
        message: data.message ? `${capitalize(data.message)}.` : 'Es ist ein Fehler beim Abruf des Service "Prüfungsverwaltung Importe" aufgetreten. Bitte versuchen Sie es später erneut.',
        type: 'error'
      });
    }

    return error.response;
  });

  const uploadExamsExcel = (formDataWithPasswordAndFile) => service({
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    url: '/pruefungen',
    data: formDataWithPasswordAndFile
  });

  const downloadExamsExcelReport = (examImportId) => service({
    method: 'get',
    responseType: 'blob',
    url: `/pruefungen/${examImportId}/report`
  });

  return {
    uploadExamsExcel,
    downloadExamsExcelReport
  };
}
